import React from 'react';
import cx from 'classnames';

import ChevronS2Right from '../Icons/ChevronS2Right';
import ChevronS2Left from '../Icons/ChevronS2Left';
import Touchable, { TouchableProps } from '../Touchable';

import baseStyles from '../PrimaryLink/PrimaryLink.module.scss';
import styles from './SecondaryLink.module.scss';

export interface Props extends TouchableProps {
  right?: boolean;
  // deprecated props, do not use
  forward?: boolean;
}

export const SecondaryLink: React.FC<Props> = ({
  forward,
  right,
  children,
  className,
  disabled,
  ...restProps
}) => (
  <Touchable
    {...restProps}
    className={cx(
      baseStyles.baseLink,
      styles.secondaryLink,
      disabled && baseStyles.disabled,
      className,
    )}
    disabled={disabled}
  >
    {!forward && !right ? (
      <ChevronS2Left className={cx(baseStyles.leftChevron)} />
    ) : null}
    {children}
    {forward || right ? (
      <ChevronS2Right className={cx(baseStyles.rightChevron)} />
    ) : null}
  </Touchable>
);

SecondaryLink.displayName = 'SecondaryLink';
export default SecondaryLink;
export { styles };
